export default {
  DocuSignLogo: {
    display: 'flex',
    alignItems: 'center',
  },
} as const
